import React from 'react';
import PropTypes from 'prop-types';
import './styles/style.scss';

const Ol = props => <p className="c-vi-ol">{props.children}</p>;

Ol.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Ol;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Ol.jsx